import React from 'react';
import styled from 'styled-components';

const Image = styled.img`
  max-width: 500px;
  height: 60px;
`;

export default function Logo({ alt, src, ...props }) {
  return <Image aria-label="Logo da empresa" {...props} src={src} alt={alt} />;
}
